export default __webpack_public_path__ + "static/media/35.a51d4dfa.png";